var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactCheck24Dp5F6368Fill0Wght200Grad0Opsz24 = function SvgFactCheck24Dp5F6368Fill0Wght200Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#5f6368",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220-300h160v-40H220zm362-88.46L751.54-558 723-586.54l-141 142-57-57L497.46-473zM220-460h160v-40H220zm0-160h160v-40H220zM120-160v-640h720v640zm40-40h640v-560H160zm0 0v-560z"
  })));
};
export default SvgFactCheck24Dp5F6368Fill0Wght200Grad0Opsz24;